/* Khanschi — AI Story builder.
   The story, the chosen design (as a file) and the preview code travel as line item properties,
   so they show on the order in Shopify admin and the design opens from there. */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function swatchClass(val) {
    if (/rose/i.test(val)) return 'rose';
    if (/rhodium|silver|white|platinum/i.test(val)) return 'silver';
    if (/gold/i.test(val)) return 'gold';
    return '';
  }

  function init(root) {
    if (root.dataset.khReady === '1') return;
    root.dataset.khReady = '1';

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-kh-data]').textContent); } catch (e) { return; }
    var products = cfg.products || [];
    var cartAdd = cfg.cart_add || '/cart/add';
    var cartUrl = cfg.cart_url || '/cart';
    var aiBackend = cfg.ai_backend || '';
    var aiTries = cfg.ai_tries || 2;

    var q = function (s) { return root.querySelector(s); };
    var form = q('[data-kh-form]');
    var elPieces = q('[data-kh-pieces]');
    var elOptions = q('[data-kh-options]');
    var elVariant = q('[data-kh-variant]');
    var elSubmit = q('[data-kh-submit]');
    var elLabel = q('[data-kh-label]');
    var elPrice = q('[data-kh-price]');
    var elHint = q('[data-kh-hint]');
    var elStory = q('[data-kh-story]');
    var elCount = q('[data-kh-count]');
    var elGen = q('[data-kh-gen]');
    var elGenLeft = q('[data-kh-gen-left]');
    var elAiNote = q('[data-kh-ai-note]');
    var elAiRes = q('[data-kh-ai-result]');
    var elAiImg = q('[data-kh-ai-img]');
    var elAiCode = q('[data-kh-ai-code]');
    var elAiErr = q('[data-kh-ai-err]');
    var elAiLoading = q('[data-kh-ai-loading]');
    var elAiStage = q('[data-kh-ai-stage]');
    var elLightbox = q('[data-kh-lightbox]');
    var elLightboxImg = q('[data-kh-lightbox-img]');
    var stageTimer = null;
    var STAGES = ['Reading your story…', 'Choosing the moment…', 'Sketching the scene…', 'Engraving the lines…', 'Polishing the pendant…'];

    var state = { product: null, opts: {} };
    var ai = { busy: false, dataUrl: null, code: null, left: null };

    function step(n) { return root.querySelector('[data-kh-step="' + n + '"]'); }
    function show(n, on) { var s = step(n); if (s) s.hidden = !on; }
    function renumber() {
      var n = 0;
      root.querySelectorAll('.khb__step').forEach(function (s) {
        if (s.hidden) return;
        n++;
        var el = s.querySelector('.khb__n');
        if (el) el.textContent = (n < 10 ? '0' : '') + n;
      });
    }
    function storyText() { return elStory ? elStory.value.trim() : ''; }

    /* ---------- the story ---------- */
    if (elStory) elStory.addEventListener('input', function () {
      if (elCount) elCount.textContent = elStory.value.length;
      aiRender(); sync();
    });

    /* ---------- the piece: one pendant today, a chooser appears if the collection grows ---------- */
    function selectProduct(p) {
      state.product = p;
      state.opts = {};
      (p.options || []).forEach(function (o, i) { state.opts[i] = o.values[0]; });
      renderOptions();
      show('ai', !!(aiBackend && p.ai));
      aiRender(); sync();
    }
    function renderPieces() {
      if (!elPieces) return;
      if (products.length <= 1) { elPieces.hidden = true; if (products[0]) selectProduct(products[0]); return; }
      elPieces.hidden = false;
      elPieces.innerHTML = products.map(function (p, i) {
        return '<button type="button" class="khb__card khb__piece" aria-pressed="false" data-kh-piece="' + i + '">' +
          '<span class="khb__piece-img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.label || p.short || p.title) + '" loading="lazy">' : '') + '</span>' +
          '<span class="khb__piece-body"><span class="khb__card-t">' + esc(p.label || p.short || p.title) + '</span>' +
          '<span class="khb__card-s">' + esc(p.price_formatted) + '</span></span></button>';
      }).join('');
      elPieces.querySelectorAll('[data-kh-piece]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          elPieces.querySelectorAll('[data-kh-piece]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          aiClear();
          selectProduct(products[parseInt(btn.getAttribute('data-kh-piece'), 10)]);
        });
      });
    }

    /* ---------- size and finish ---------- */
    function variantFor(opts) {
      var p = state.product;
      if (!p) return null;
      var want = (p.options || []).map(function (_, i) { return opts[i]; });
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i], ok = true;
        for (var j = 0; j < want.length; j++) { if (v.options[j] !== want[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function valueUsable(oi, val) {
      var trial = Object.assign({}, state.opts);
      trial[oi] = val;
      var v = variantFor(trial);
      return !!(v && v.available);
    }
    function renderOptions() {
      var p = state.product;
      if (!elOptions || !p) return;
      elOptions.innerHTML = (p.options || []).map(function (o, oi) {
        var isSwatch = /metal|finish|colou?r/i.test(o.name);
        return '<div class="khb__optgroup"><span class="khb__optlabel">' + esc(o.name) + '</span><div class="khb__pills">' +
          o.values.map(function (val) {
            var sw = isSwatch ? swatchClass(val) : '';
            return '<button type="button" class="khb__pill' + (sw ? ' khb__pill--swatch' : '') + '" data-kh-opt="' + oi + '" data-kh-val="' + esc(val) + '" ' +
              'aria-pressed="' + (state.opts[oi] === val) + '"' + (valueUsable(oi, val) ? '' : ' disabled') + '>' +
              (sw ? '<span class="khb__dot khb__dot--' + sw + '"></span>' : '') + esc(val) + '</button>';
          }).join('') + '</div></div>';
      }).join('');
      elOptions.querySelectorAll('[data-kh-opt]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.opts[parseInt(btn.getAttribute('data-kh-opt'), 10)] = btn.getAttribute('data-kh-val');
          renderOptions();
          sync();
        });
      });
    }

    /* ---------- the design: the server counts the tries; the page only remembers what it was told today ---------- */
    function aiRemember(left) { ai.left = left; } /* server is the only counter; nothing is cached across reloads */
    function aiLeft() { return ai.left === null ? aiTries : Math.max(0, ai.left); }
    function aiRender() {
      if (!elGen) return;
      var left = aiLeft();
      if (elGenLeft) elGenLeft.textContent = ai.left === null ? '(' + aiTries + ' tries)' : (left > aiTries ? '' : left ? '(' + left + ' left)' : '');
      elGen.disabled = ai.busy || !left || storyText().length < 10;
      if (elAiNote && !ai.busy) {
        elAiNote.textContent = !left ? 'Both tries used for today. Your design proof still comes by email before we make anything.' :
          storyText().length < 10 ? 'Write your story first.' : '';
      }
    }
    function aiClear() {
      ai.dataUrl = null; ai.code = null;
      if (elAiRes) elAiRes.hidden = true;
      if (elAiImg) elAiImg.removeAttribute('src');
      if (elAiCode) { elAiCode.value = ''; elAiCode.disabled = true; }
      aiRender(); sync();
    }
    function aiGenerate() {
      if (ai.busy || !aiLeft() || !state.product || storyText().length < 10) return;
      var v = variantFor(state.opts);
      var image = state.product.ai_image || (v && v.image) || state.product.image; /* blank disc for the AI; the shop photo may carry text */
      var vid = '';
      try { vid = localStorage.getItem('kh_vid') || ''; if (!vid) { vid = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem('kh_vid', vid); } } catch (e) { vid = (document.cookie.match(/khcid=([a-z0-9]+)/) || [])[1] || ''; }
      if (!/khcid=/.test(document.cookie)) document.cookie = 'khcid=' + (vid || Math.random().toString(36).slice(2)) + ';path=/;max-age=31536000';
      ai.busy = true;
      if (elAiErr) elAiErr.textContent = '';
      if (elAiNote) elAiNote.textContent = '';
      if (elAiRes) elAiRes.hidden = true;
      busyStart();
      aiRender();
      var img = /^\/\//.test(image || '') ? 'https:' + image : image;
      fetch(aiBackend + '/api/story/preview', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          visitorId: vid,
          story: storyText(),
          productImage: img,
          finish: v ? v.options[0] : '',
          size: v && v.options.length > 1 ? v.options[1] : ''
        })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, status: r.status, body: b }; }, function () { return { ok: false, status: r.status, body: null }; }); })
        .then(function (res) {
          ai.busy = false;
          busyStop();
          if (!res.ok || !res.body || !res.body.previewDataUrl) {
            if (res.status === 429) aiRemember(0);
            throw new Error(res.status === 404 ? 'Design previews are being set up. You can still order — your design proof comes by email.' :
              (res.body && res.body.error) || 'The design did not come through. Please try again.');
          }
          if (typeof res.body.left === 'number') aiRemember(res.body.left);
          ai.dataUrl = res.body.previewDataUrl; ai.code = res.body.previewId || '';
          if (elAiImg) elAiImg.src = ai.dataUrl;
          if (elAiRes) elAiRes.hidden = false;
          if (elAiCode) { elAiCode.value = ai.code; elAiCode.disabled = !ai.code; }
          if (elAiNote) elAiNote.textContent = aiLeft() ? 'Not quite it? Add a detail to your story and try once more.' : '';
          aiRender(); sync();
        })
        .catch(function (e) { ai.busy = false; busyStop(); if (elAiNote) elAiNote.textContent = ''; if (elAiErr) elAiErr.textContent = e.message; aiRender(); });
    }
    function busyStart() {
      var i = 0;
      if (elAiStage) elAiStage.textContent = STAGES[0];
      if (elAiLoading) { elAiLoading.hidden = false; elAiLoading.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
      if (elGen) elGen.innerHTML = '<span class="khb__spin"></span>Drawing…';
      clearInterval(stageTimer);
      stageTimer = setInterval(function () { i = Math.min(i + 1, STAGES.length - 1); if (elAiStage) elAiStage.textContent = STAGES[i]; }, 9000);
    }
    function busyStop() {
      clearInterval(stageTimer);
      if (elAiLoading) elAiLoading.hidden = true;
      if (elGen) elGen.innerHTML = 'Create my design <span data-kh-gen-left></span>';
      elGenLeft = q('[data-kh-gen-left]');
    }
    /* full size and download */
    function openLightbox() { if (!ai.dataUrl || !elLightbox) return; elLightboxImg.src = ai.dataUrl; document.body.appendChild(elLightbox); /* last in body: wins over app widgets at the same z-index */ elLightbox.hidden = false; document.body.style.overflow = 'hidden'; }
    function closeLightbox() { if (!elLightbox) return; elLightbox.hidden = true; document.body.style.overflow = ''; }
    function downloadDesign() {
      if (!ai.dataUrl) return;
      var a = document.createElement('a');
      a.href = ai.dataUrl; a.download = 'khanschi-design-' + (ai.code || 'preview') + '.jpg';
      document.body.appendChild(a); a.click(); a.remove();
    }
    root.querySelectorAll('[data-kh-ai-open]').forEach(function (b) { b.addEventListener('click', openLightbox); });
    root.querySelectorAll('[data-kh-ai-download]').forEach(function (b) { b.addEventListener('click', downloadDesign); });
    var elLbClose = q('[data-kh-lightbox-close]');
    if (elLbClose) elLbClose.addEventListener('click', closeLightbox);
    if (elLightbox) elLightbox.addEventListener('click', function (ev) { if (ev.target === elLightbox) closeLightbox(); });
    if (elLightbox && elLightbox.parentElement !== document.body) document.body.appendChild(elLightbox); /* fixed to the viewport, never clipped by theme wrappers */
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeLightbox(); });
    if (elGen) elGen.addEventListener('click', aiGenerate);
    var elAiClear = q('[data-kh-ai-clear]');
    if (elAiClear) elAiClear.addEventListener('click', aiClear);

    /* ---------- keep the button honest ---------- */
    function sync() {
      var v = variantFor(state.opts);
      if (elVariant) elVariant.value = v ? v.id : '';
      if (elPrice) {
        var shown = v ? v.price_formatted : (state.product ? state.product.price_formatted : '');
        elPrice.textContent = shown || '';
      }
      if (v && v.image && elPieces && !elPieces.hidden) {
        var card = elPieces.querySelector('[data-kh-piece="' + products.indexOf(state.product) + '"] img');
        if (card) card.src = v.image;
      }
      var storyOk = storyText().length >= 10;
      var ready = !!(storyOk && state.product && v && v.available);
      if (elSubmit) elSubmit.disabled = !ready;
      if (elHint) {
        elHint.textContent = ready ? '' :
          !storyOk ? 'Tell your story to continue — a sentence is enough.' :
          !state.product ? 'Choose your piece to continue.' :
          'That combination is not available right now.';
      }
      renumber();
    }

    /* ---------- add to cart: the chosen design rides along as a file ---------- */
    form.addEventListener('submit', function (ev) {
      if (!window.FormData || !window.fetch) return;
      ev.preventDefault();
      if (elAiErr) elAiErr.textContent = '';
      elSubmit.disabled = true;
      var label = elLabel ? elLabel.textContent : '';
      if (elLabel) elLabel.textContent = cfg.adding_label || 'Adding…';
      var fd = new FormData(form);
      var send = Promise.resolve(fd);
      if (ai.dataUrl) {
        send = fetch(ai.dataUrl).then(function (r) { return r.blob(); }).then(function (blob) {
          fd.append('properties[Chosen Design]', blob, 'khanschi-design-' + (ai.code || 'preview') + '.jpg');
          return fd;
        }).catch(function () { return fd; });
      }
      send.then(function (body) { return fetch(cartAdd + '.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Could not add this to your cart.');
          window.location.href = cartUrl;
        })
        .catch(function (e) {
          if (elAiErr) elAiErr.textContent = e.message;
          if (elLabel) elLabel.textContent = label;
          sync();
        });
    });

    renderPieces();
    aiRender();
    sync();
  }

  function boot() { document.querySelectorAll('[data-kh-keepsake]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
